import { ButtonView, IconImage, Locale, Plugin } from 'ckeditor5';
import { QualioAttachmentPreviewCommand } from './QualioAttachmentPreviewCommand';

export class QualioAttachmentPreviewPlugin extends Plugin {
  init() {
    const editor = this.editor;

    const command = new QualioAttachmentPreviewCommand(this.editor);
    this.editor.commands.add(
      QualioAttachmentPreviewCommand.commandName,
      command,
    );

    editor.ui.componentFactory.add(
      QualioAttachmentPreviewCommand.commandName,
      (locale: Locale) => {
        const view = new ButtonView(locale);

        view.set({
          label: 'View attachment preview',
          icon: IconImage,
          tooltip: true,
        });

        view.bind('isVisible').to(command, 'isEnabled');

        view.on('execute', () => {
          editor.execute(QualioAttachmentPreviewCommand.commandName);
        });

        return view;
      },
    );
  }
}
